import React from 'react';
import DateTime from 'luxon/src/datetime';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'Components/Modal';
import { PrimaryButton, DangerButton } from 'Components/Button';

import Sessions from 'Services/Api/Admin/MainStage/Sessions';
import { Toast } from 'Services';

export default class SwitchStream extends React.Component {
    /**
     * @var state
     * @type {{working: boolean}}
     */
    state = {
        working: false,
    };

    /**
     * @method handleUpdate
     * @return {Promise<void>}
     */
    handleUpdate = async () => {
        this.setState({ working: true });
        const { session } = this.props;

        const request = await Sessions.patch({
            session: session.id,
        }, {
            ...session,
            stream_src: session.stream_src === 'primary' ? 'secondary' : 'primary',
        });

        if (request.success) {
            Toast.success('Session has been updated');
            return this.props.onClose();
        }

        Toast.error();
        this.setState({ working: false });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { working } = this.state;
        const { session } = this.props;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    Change Source
                </ModalHeader>

                <ModalBody>
                    <p className="text-center">
                        Are you sure you want to switch to the {session.stream_src === 'primary' ? 'secondary' : 'primary'} source?
                    </p>
                </ModalBody>

                <ModalFooter alignment="center">
                    <PrimaryButton text="Cancel" working={working} onClick={this.props.onClose} className="mr-2"/>
                    <DangerButton text="Continue" working={working} onClick={this.handleUpdate}/>
                </ModalFooter>
            </Modal>
        );
    }
}
